export const environment = {
  production: true,
  rootUrl: 'https://jmte.kr',
  toss: {
    widgetClientKey: 'test_gck_ALnQvDd2VJPL74gWqWja8Mj7X41m',
    apiKey: 'test_ck_kYG57Eba3G4PMY2D9qZ9VpWDOxmA',
  },
};
